import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "webradio";

  connect() {
    super.connect();

    const element = this.bridgeElement;
    const url = element.bridgeAttribute("url");
    this.send("connect", { url }, () => {});
  }
}
